//For fetching events

export const QUERY_KEYS = {
  events: (limit) => ["events", limit],
  archivedEvents: (limit) => ["archivedEvents", limit],
};
